import { PERMISSIONS } from "../constants/permissions";

// 発注担当者として注文に紐付け可能な権限の一覧
export const AUTHORIZED_ORDER_USER_ROLES = [
  PERMISSIONS.ADMINISTRATOR,
  PERMISSIONS.HUMAN_RESOURCE_USER,
  PERMISSIONS.ORDER_USER,
];

const isAdministrator = (role) => {
  return (
    role === PERMISSIONS.ADMINISTRATOR ||
    role === PERMISSIONS.HUMAN_RESOURCE_USER
  );
};
const isUpperNormal = (role) => {
  return (
    role === PERMISSIONS.ADMINISTRATOR ||
    role === PERMISSIONS.HUMAN_RESOURCE_USER ||
    role === PERMISSIONS.ORDER_USER
  );
};

// 発注担当者として注文に紐付け可能か (= AUTHORIZED_ORDER_USER_ROLES に含まれるか)
const isAuthorizedOrderUser = (role) => {
  return AUTHORIZED_ORDER_USER_ROLES.includes(role);
};

export { isAdministrator, isUpperNormal, isAuthorizedOrderUser };
